import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class StickyButton extends UcoastEl {
    static htmlSelector = 'sticky-button'

    button: HTMLLinkElement
    wrapper: HTMLElement

    constructor() {
        super()
        this.button = q.rs('a', this)
        this.wrapper = q.rs('.sticky-button-wrapper', document)
    }

    override connectedCallback(): void {
        const handleScroll = () => {
            const previousElementSibling = this.previousElementSibling
            if(!previousElementSibling) return
            if(previousElementSibling.getBoundingClientRect().bottom <= window.innerHeight - this.button.offsetHeight - 45) {
                if(!this.wrapper.querySelector('a')) this.wrapper.appendChild(this.button)
            } else {
                if(!this.querySelector('a')) this.appendChild(this.button)
            }
        }
        window.addEventListener('scroll', handleScroll, { passive: true })
        handleScroll()
    }
}
